/** Sistem menüsü — geliştirici alanı (Dosyalar hariç) */
export const SYSTEM_DEV_ZONE_PATHS = [
  '/db-yedekleme',
  '/test-veri-temizle',
  '/egitim-ts-kayitlari',
  '/sisteme-randevu-test',
  '/apk-surumleri',
  '/yapilacaklar',
  '/teknik-servisler/il-etiketleri',
];

export function isSystemDevZonePath(pathname = '') {
  const path = pathname || '';
  return SYSTEM_DEV_ZONE_PATHS.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}
